import {
  Badge,
  Box,
  Button,
  ButtonGroup,
  Flex,
  Image,
  Link,
  ScaleFade,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { CgWebsite } from "react-icons/cg";
import { AiFillGithub } from "react-icons/ai";
import { useRef } from "react";
import { useEffect } from "react";

const ProjectsCard = ({ project }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [flag, setFlag] = useState(false);
  const ref = useRef(null);

  window.addEventListener("scroll", function (e) {
    fadeAnimate();
  });

  const fadeAnimate = () => {
    var containerTop = ref.current.getBoundingClientRect().top;
    if (containerTop < 400) {
      if (!flag) {
        onOpen();
        setFlag(true);
      }
    }
    if (containerTop >= 400) {
      setFlag(false);
      onClose();
    }
  };

  return (
    // <ScaleFade initialScale={0.9} in={isOpen}>
    <Flex
      ref={ref}
      flexDir="column"
      p="4"
      bg="blackAlpha.100"
      backdropFilter="auto"
      backdropBlur="4px"
      borderRadius="10px"
      boxShadow="inset 0 0 10px rgba(255, 255, 255, .5)"
    >
      <Box>
        <Image src={project.img} alt="project" draggable={false} />
      </Box>
      <Box>
        <Stack gap="20px">
          <Text
            bgGradient="linear(to-r, #fff, #008080)"
            bgClip="text"
            fontSize={{ lg: "27px", md: "24px", sm: "20px" }}
            fontWeight="extrabold"
          >
            {project.title}
          </Text>
          <Text
            h={{ lg: "150px", md: "75px", sm: "75px", base: "70px" }}
            fontSize={{ lg: "16.5px", md: "14px", sm: "12px", base: "12px" }}
            color="#fff"
          >
            {project.description}
          </Text>
          <Text h={{ lg: "60px", md: "40px" }} color="#fff">
            {project.techStack.map((el) => {
              return (
                <Badge
                  key={Math.random() * 60.821787 * 0.6565}
                  fontSize={{ lg: "14px", md: "12px", sm: "11px" }}
                  ml="5px"
                  colorScheme="teal"
                  variant="outline"
                >
                  {el}
                </Badge>
              );
            })}
          </Text>
          <Text>
            <ButtonGroup variant="outline" spacing="6">
              <Link
                _hover={{ textDecoration: "none" }}
                isExternal={true}
                href={project.github}
              >
                <Button fontWeight="bold" colorScheme="teal">
                  {" "}
                  <Flex align="center">
                    <Text mr="6px">Code</Text>
                    <Text>
                      <AiFillGithub />
                    </Text>
                  </Flex>
                </Button>
              </Link>
              <Link
                _hover={{ textDecoration: "none" }}
                isExternal={true}
                href={project.website}
              >
                <Button
                  color="#fff"
                  _hover={{ color: "#000", bgColor: "#fff" }}
                >
                  {" "}
                  <Flex align="center">
                    <Text mr="6px">Live</Text>
                    <Text>
                      <CgWebsite />
                    </Text>
                  </Flex>
                </Button>
              </Link>
            </ButtonGroup>
          </Text>
        </Stack>
      </Box>
    </Flex>
    // </ScaleFade>
  );
};

export default ProjectsCard;
